/**
 * EZTree 隨機數生成器（從 @dgreenheck/ez-tree 移植）
 *
 * 確定性 PRNG，相同 seed 產生相同結果
 */

export default class RNG {
  private m_w: number
  private m_z: number
  private mask = 0xffffffff

  constructor(seed: number) {
    this.m_w = (123456789 + seed) & this.mask
    this.m_z = (987654321 - seed) & this.mask
  }

  /** 回傳 [min, max) 之間的隨機數 */
  random(max = 1, min = 0): number {
    this.m_z = (36969 * (this.m_z & 65535) + (this.m_z >> 16)) & this.mask
    this.m_w = (18000 * (this.m_w & 65535) + (this.m_w >> 16)) & this.mask
    let result = ((this.m_z << 16) + (this.m_w & 65535)) >>> 0
    result /= 4294967296
    return (max - min) * result + min
  }
}
